import {
  CITATIONS_LIST_CONTAINER,
  CITATIONS_LIST_CONTAINER_COLLAPSED,
  CITATIONS_SHOW_ALL
} from '../classnames/scientific-citations';
import { HIDDEN } from '../classnames/design-system';

export default class CitationLinksContainer {
  collapsedLinksConatiner = document.querySelector(`.${CITATIONS_LIST_CONTAINER}`);
  showAllButton = document.querySelector(`.${CITATIONS_SHOW_ALL}`);

  expand = () => {
    this.collapsedLinksConatiner.classList.remove(CITATIONS_LIST_CONTAINER_COLLAPSED);
    this.showAllButton.classList.add(HIDDEN);
  };
}
